import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMfrFeedDoorClosing = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.12652 13.3484C7.41941 13.6412 7.41941 14.1161 7.12652 14.409L5.0052 16.5303C4.7123 16.8232 4.23743 16.8232 3.94454 16.5303L1.82322 14.409C1.53032 14.1161 1.53032 13.6412 1.82322 13.3484C2.11611 13.0555 2.59098 13.0555 2.88388 13.3484L3.72487 14.1893V11.0503C3.72487 10.636 4.06065 10.3003 4.47487 10.3003C4.88908 10.3003 5.22487 10.636 5.22487 11.0503V14.1893L6.06586 13.3484C6.35875 13.0555 6.83362 13.0555 7.12652 13.3484Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.0069 4.88235C14.066 4.38115 14.4914 4 15 4H18C18.2931 4 18.5715 4.12862 18.7615 4.35186C18.8906 4.50355 18.9701 4.68856 18.9931 4.88235H21C21.2956 4.88235 21.5761 5.01317 21.7661 5.23968C21.9561 5.46618 22.0362 5.76515 21.9848 6.05628L20.3027 15.5796L21.1245 19.8093C21.1814 20.1024 21.1044 20.4057 20.9144 20.6361C20.7245 20.8665 20.4415 21 20.1429 21H9.85714C9.55851 21 9.2755 20.8665 9.08554 20.6361C8.89558 20.4057 8.81854 20.1024 8.87549 19.8093L9.69727 15.5796L8.01524 6.05628C7.96382 5.76515 8.04385 5.46618 8.23386 5.23968C8.42386 5.01317 8.70435 4.88235 8.99999 4.88235H14.0069ZM13.8443 6.88235H10.1921L11.5531 14.5882H13.2205L13.8443 6.88235ZM17.4606 14.5882H18.4469L19.8079 6.88235H18.7083L17.4606 14.5882ZM16.8251 6H15.9223L15.4414 11.9412H15.8632L16.8251 6ZM18.4613 16.5882H11.5387L11.0701 19H18.9299L18.4613 16.5882Z",
		fill: "currentColor"
	})]
});
export default SvgMfrFeedDoorClosing;
